import _ from 'lodash';
import React, { Component } from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import { getDonorsFromFolder } from '../../../utils/donorHelpers';
import { bestFit } from '../../../utils/screenUtils';
import { parseTextStyling } from '../../../utils/shared';
import BRSpan from '../../General/BRSpan';
import { DEFAULT_CYCLE } from './AlbuquerqueConstants';



class AlbuquerqueDonorList extends Component {
  constructor(props) {
    super(props);

    const dims = bestFit(1920, 1080, props.width || 1920, props.height || 1080);

    this.state = {
      listData: {
        donors: [],
        title: '',
        category: '',
        description: '',
        cycleIndex: 0
      },
      timestamp: null,
      finishedPreRender: false,
      fadeIn: true,
      width: dims.width,
      height: dims.height
    };

    this._donorCycleTimeout = null;
    this.donorList = null;
    this._donorRefs = [];
    this._underlineRef = null;
    this._donorContainerRef = null;
    this._donorContainer = {
      height: 0,
      width: 0
    }
    this._donorIndex = 0;
    this._categoryIndex = 0;
    this._lastPageCount = 0;
    this._cycle_time = 5000;

    this._layout = {
      margin_left: .05,
      margin_bottom: .1,
      title_offset: .025,
      description_offset: .10,
      names_offset: .125
    }
  }

  componentWillMount() {
    let donors = getDonorsFromFolder(this.props.donors, this.props.content.folder_modules, this.props.module.id);
    donors = _.orderBy(donors, [d => d.sorting_name.toLowerCase()], ['asc']);
    this._donorList = { ...this.props.module, donors };
  }
  
  componentDidMount() {
    const columns = _.get(this._donorList, 'contents.custom_fields.columns.val', _.get(this._donorList, 'contents.custom_fields.columns.default', 2));
    const marginLeft = _.get(this._donorList, 'contents.custom_fields.margin_left.val', _.get(this._donorList, 'contents.custom_fields.margin_left.default', 10));
    const donorMarginLeft = _.get(this._donorList, 'contents.custom_fields.donor_margin_left.val', _.get(this._donorList, 'contents.custom_fields.donor_margin_left.default', 10));
    const topOffset = _.get(this._donorList, 'contents.custom_fields.top_offset.val', _.get(this._donorList, 'contents.custom_fields.top_offset.default', 12.5));
    const titleOffset = _.get(this._donorList, 'contents.custom_fields.title_offset.val', _.get(this._donorList, 'contents.custom_fields.title_offset.default', 2.5));
    const descriptionOffset = _.get(this._donorList, 'contents.custom_fields.description_offset.val', _.get(this._donorList, 'contents.custom_fields.description_offset.default', 10));

    this._layout.columns = columns / 100;
    this._layout.margin_left = marginLeft / 100;
    this._layout.donor_margin_left = donorMarginLeft / 100;
    this._layout.names_offset = topOffset / 100;
    this._layout.title_offset = titleOffset / 100;
    this._layout.description_offset = descriptionOffset / 100;

    this._layout.title_offset = 0.075
    this._layout.description_offset = 0.1

    this._background = "";
    try {
      document.addEventListener("keydown", this.handleKeyDown);
      
      setTimeout(() => {
        this.handlePreRender();
        this.setDonorListStateData();
        this.cycleNameSet();
      }, 500);
    } catch (e) {
      console.log(e);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.width !== this.props.width || prevProps.height !== this.props.height) {
      const dims = bestFit(1920, 1080, this.props.width, this.props.height);
      this.setState({
        width: dims.width,
        height: dims.height
      })
    }

    if (prevProps.cycleIndex !== this.props.cycleIndex && this.props.cycleIndex > 0) {
      const endOfLoop = this.cycleDonorIndex();
      if (endOfLoop) {
        this.props.cycle(true);
      } else {
        this.setState({});
        this.cycleNameSet();
      }
    }
  }

  componentWillUnmount() {
    clearTimeout(this._donorCycleTimeout);
  }

  setDonorListStateData = () => {
    const title = _.get(this._donorList, 'name', '');
    const category = _.get(this._donorList, 'contents.custom_fields.subheader.val', '');
    const description = _.get(this._donorList, 'contents.custom_fields.description.val', '');

    this.setState({
      listData: {
        title,
        category,
        description
      }
    });
  }

  handlePreRender = () => {
    if (this._donorRefs.length > 0 && this.state.finishedPreRender === false) {

      let counter = -1;

      this._donorList.donors.forEach((donor) => {        
        counter++;
        donor.height = this._donorRefs[counter].offsetHeight;
        donor.width = this._donorRefs[counter].offsetWidth;
      });

      this._donorContainer = {
        width: this._donorContainerRef.offsetWidth,
        height: this._donorContainerRef.offsetHeight
      }
      this.setState({
        finishedPreRender: true
      });
    }
  }

  handleKeyDown = (event) => {
    switch (event.key) {
      case "c":
        this.cycleDonorIndex();
        break;
      default:
        break;
    }
  }

  getCategoryStyle = (style = {}) => {
    style.fontSize = this.state.height * .026
    style.fontStyle = "Normal";
    style.fontFamily = "Lato";
    style.fontWeight = "100";
    style.paddingBottom = this.state.height * .008
    style.lineHeight = 2.75;
    style.textAlign = 'left';
    style.fontColor = '#000000';

    return style;
  }

  preRenderDonors = () => {
    let flatDonors = []

    let columns = _.get(this._donorList, 'contents.custom_fields.columns.val', _.get(this._donorList, 'contents.custom_fields.columns.default', 3));
    let columnWidth = this.state.width * .8 / columns;
    const styleObj = _.get(this._donorList, 'contents.custom_fields.donor_name_style', null);
    const style = parseTextStyling(styleObj);
    style.lineHeight = "4vh";
    this._donorList.donors.forEach((donor) => {
      // let donorStyleCopy = {};
      donor.style = style;
      // delete donor.style.lineHeight;
      donor.style.width = columnWidth * .9;
      flatDonors.push(donor);
    });
    
    return (
      flatDonors.map((donor, i) => {
        return (
          <div key={i} ref={el => this._donorRefs[i] = el} style={{ ...donor.style, opacity: 0 }}><BRSpan str={donor.name} /></div>
        )
      })
    )
  }

  cycleNameSet = () => {
    this._cycle_time = _.get(this.props.module, "contents.custom_fields.cycle_time.val", DEFAULT_CYCLE);
    clearTimeout(this._donorCycleTimeout);
    this._donorCycleTimeout = setTimeout(() => {
      const endOfLoop = this.cycleDonorIndex();
      if (!endOfLoop) {
        this.setState({});
        this.cycleNameSet();
      } else {
        if (this.props.cycle) {
          this.props.cycle();
        } else {
          this._donorIndex = 0
          this.cycleNameSet();
        }
      }
    }, this._cycle_time * 1000);
  }

  cycleDonorIndex = () => {
    if (this._donorIndex + this._lastPageCount >= this._donorList.donors.length) {
      return true;
    } else {
      this._donorIndex += this._lastPageCount;
      return false;
    }
  }

  renderNames = () => {
    const donorCategory = this._donorList;
    let columns = _.get(donorCategory, 'contents.custom_fields.columns.val', _.get(donorCategory, 'contents.custom_fields.columns.default', 3));
    let currentHeight = 0;
    let currentColumn = 1;
    let drawDonors = [];
    let columnWidth = this._donorContainer.width / columns;
    this._lastPageCount = 0;

    for (var a = this._donorIndex; a < this._donorList.donors.length; a++) {
      let donor = this._donorList.donors[a];
      //fits in column
      if ((currentHeight + donor.height) > (this._donorContainer.height - this._layout.margin_bottom * this.state.height)) {
        if (currentColumn < columns) {
          //reset for new column
          currentHeight = 0;
          currentColumn++;
        } else {
          break
        }
      }

      donor.top = currentHeight;
      donor.column = currentColumn;
      // console.log(donor.height);
      const verticalOffset = _.get(this.props.module, 'contents.custom_fields.donor_vertical_offset.val', _.get(this.props.module, 'contents.custom_fields.donor_vertical_offset.default', 5));
      currentHeight += donor.height + (this.props.height * Number(verticalOffset) / 100);
      drawDonors.push(donor);
      this._lastPageCount++;
    }

    // const modifiedDonorStyle = this.getCategoryStyle(donorStyle);
    const styleObj = _.get(this._donorList, 'contents.custom_fields.donor_name_style', null);
    const style = parseTextStyling(styleObj);
    style.lineHeight = "4vh";
    
    return (
      drawDonors.map((item, i) => {
        const left = (item.column - 1) * columnWidth * (1 + this._layout.donor_margin_left);
        return (
          <div key={i} style={{ ...style, position: "absolute", overflow: "hidden", top: item.top, left, opacity: 1, width: columnWidth * .9 }}>
            <div className="empty-br">
              <BRSpan className="empty-br" str={item.name} />
            </div>
          </div>
        )
      })
    )
  }

  render() {
    if (!this._donorList || !this._donorList.donors || !this._donorList.donors.length) {
      return null;
    }
    // const description_font_size = this.state.height * .03;
    const margin_left = this.state.width * this._layout.margin_left;
    const title_offset = this.state.height * this._layout.title_offset;
    // const description_offset = this.state.height * this._layout.description_offset
    const names_offset = this.state.height * this._layout.names_offset

    const titleStyleObj = _.get(this._donorList, 'contents.custom_fields.header_style', null);
    const titleStyle = parseTextStyling(titleStyleObj);
    const subheaderStyleObj = _.get(this._donorList, 'contents.custom_fields.subheader_style', null);
    const subheaderStyle = parseTextStyling(subheaderStyleObj);
    const deceased = _.get(this._donorList, 'contents.custom_fields.deceased.val', false);
    const underline = _.get(this._donorList, 'contents.custom_fields.horizontal_line.val', _.get(this._donorList, 'contents.custom_fields.horizontal_line.default', false));

    return (
      <div>
        {/* <div style={{ position: "absolute", width: "100%", height: "100%", opacity: OPACITY_PERCENTAGE, backgroundColor: OPACITY_COLOR }}/> */}
        <div style={{ width: this.state.width, height: this.state.height, background: `url(${this._background})`, backgroundSize: "cover" }}>
          <div className="denver-donor-list" style={{ position: 'absolute', width: this.state.width, height: this.state.height, left: margin_left }}>
            {/* Donor list name, category */}
            <CSSTransitionGroup
              component='div'
              transitionName='example'
              transitionEnterTimeout={0}
              transitionLeaveTimeout={0}>
              <div key={'header-' + this._categoryIndex} style={{ position: "absolute", top: title_offset, width: this.state.width * .9, height: this.state.height * .05 }}>
                {this.state.listData && this.state.listData.title ?
                  <div>
                    <div style={titleStyle}>{this.state.listData.title}</div>
                    {
                      underline ?
                      <div style={{ backgroundColor: 'white', opacity: 1, width: this.props.width * .8875, height: '1px', position: "relative", top: "1.54vh" }} />
                      :
                      <div style={subheaderStyle}>{this.state.listData.category}</div>
                    }

                  </div>
                  :
                  null
                }
              </div>

            </CSSTransitionGroup>

            <div ref={el => this._donorContainerRef = el} style={{ position: 'absolute', width: this.state.width * .8, height: this.state.height * .8, zIndex: 1, top: names_offset, opacity: 1 }}>
              <CSSTransitionGroup
                component='div'
                transitionName='slowfade'
                transitionEnterTimeout={0}
                transitionLeaveTimeout={0}>
                {this.state.finishedPreRender ?
                  <div key={"donor-index" + this._donorIndex + "-category-index-" + this._categoryIndex}>
                    {this.renderNames()}
                  </div>
                  :
                  this.preRenderDonors()}
              </CSSTransitionGroup>
            </div>

            <div style={{ position: "absolute", right: "24.69vh", bottom: "4.62vh" }}>
              <CSSTransitionGroup
                component='div'
                transitionName='slowfade'
                transitionEnterTimeout={0}
                transitionLeaveTimeout={0}>
                  {
                    deceased ?
                    <div key={'header-' + this._categoryIndex} style={{ fontFamily: "legacysans-book", color: "white", fontSize: "2.46vh" }}>
                      <span>*Deceased</span>
                    </div>
                    : null
                  }
              </CSSTransitionGroup>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AlbuquerqueDonorList;


// WEBPACK FOOTER //
// ./src/Components/Theme/Albuquerque/AlbuquerqueDonorList.jsx